import { inject, Injectable } from '@angular/core';
import {
  DefaultMissingHandler,
  Translation,
  TranslocoLoader,
  TranslocoMissingHandler
} from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

@Injectable()
export class CustomTranslocoMissingHandler
  extends DefaultMissingHandler
  implements TranslocoMissingHandler
{
  override handle(key: string) {
    console.warn('Missing translation', key);
    return key;
  }
}
